import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchMenuFromServer, fetchSettingsFromServer } from 'src/api/settings'

import { FooterType, SettingsSliceState } from './types'

const initialState: SettingsSliceState = {
    ready: false,
    slugs: {},
    logo: '',
    bgcolor: '',
    textcolor: '',
    background: '',
    language: 'en',
    languages: {},
    ajaxurl: '',
    components: {} as Record<string, any>,
    footer: {} as FooterType,
    labels: {},
    menu: [],
} as SettingsSliceState

export const fetchSettings = createAsyncThunk('settings/fetchSettings', async () => {
    const response = await fetchSettingsFromServer()
    return response
})

export const fetchMenu = createAsyncThunk('settings/fetchMenu', async () => {
    const response = await fetchMenuFromServer()
    return response
})

export const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setUnderConstruction: (state, action) => {
            return {
                ...state,
                underConstruction: action.payload,
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSettings.fulfilled, (state, action) => {
            console.log('Settings fetched:', action.payload) // Debug log
            if (action.payload.bgcolor && action.payload.textcolor) {
                //set css variables for background and text color
                document.documentElement.style.setProperty('--colors-brand', action.payload.bgcolor)
                document.documentElement.style.setProperty('--colors-text', action.payload.textcolor)
            }
            return {
                ...state,
                ready: true,
                ...action.payload,
            }
        })
        builder.addCase(fetchMenu.fulfilled, (state, action) => {
            return {
                ...state,
                menu: action.payload,
            }
        })
    },
})

export const { setUnderConstruction } = settingsSlice.actions
export default settingsSlice.reducer
